// Maps 2-letter to 3-letter ISO codes for countries with regions
export const COUNTRIES_WITH_REGIONS_CODE_MAP = {
  US: 'USA',
  GB: 'GBR',
  DE: 'DEU',
}

export const COUNTRIES_WITH_REGIONS = ['US', 'GB', 'DE']

export const COUNTRIES_CODE_MAP = {
  FRA: {
    alpha2Code: 'FR',
    countryName: 'France',
    center: [46.6034, 1.8883],
  },
  DEU: {
    alpha2Code: 'DE',
    countryName: 'Germany',
    center: [51.1657, 10.4515],
  },
  ISR: {
    alpha2Code: 'IL',
    countryName: 'Israel',
    center: [31.0461, 34.8516],
  },
  ITA: {
    alpha2Code: 'IT',
    countryName: 'Italy',
    center: [41.8719, 12.5674],
  },
  ESP: {
    alpha2Code: 'ES',
    countryName: 'Spain',
    center: [40.4637, -3.7492],
  },
  GBR: {
    alpha2Code: 'GB',
    countryName: 'United Kingdom',
    center: [55.3781, -3.436],
  },
  USA: {
    alpha2Code: 'US',
    countryName: 'United States of America',
    center: [37.0902, -95.7129],
  },
  EU: {
    alpha2Code: 'EU',
    countryName: 'European Union',
    center: [50.1109, 8.6821], // Approximate center of the EU (Frankfurt, Germany)
  },
  AFG: {
    alpha2Code: 'AF',
    countryName: 'Afghanistan',
    center: [33.9391, 67.71],
  },
  ALB: {
    alpha2Code: 'AL',
    countryName: 'Albania',
    center: [41.1533, 20.1683],
  },
  DZA: {
    alpha2Code: 'DZ',
    countryName: 'Algeria',
    center: [28.0339, 1.6596],
  },
  ASM: {
    alpha2Code: 'AS',
    countryName: 'American Samoa',
    center: [-14.271, -170.1322],
  },
  AND: {
    alpha2Code: 'AD',
    countryName: 'Andorra',
    center: [42.5078, 1.5211],
  },
  AGO: {
    alpha2Code: 'AO',
    countryName: 'Angola',
    center: [-11.2027, 17.8739],
  },
  AIA: {
    alpha2Code: 'AI',
    countryName: 'Anguilla',
    center: [18.2206, -63.0686],
  },
  ATA: {
    alpha2Code: 'AQ',
    countryName: 'Antarctica',
    center: [-82.8628, 135.0],
  },
  ATG: {
    alpha2Code: 'AG',
    countryName: 'Antigua and Barbuda',
    center: [17.0608, -61.7964],
  },
  ARG: {
    alpha2Code: 'AR',
    countryName: 'Argentina',
    center: [-38.4161, -63.6167],
  },
  ARM: {
    alpha2Code: 'AM',
    countryName: 'Armenia',
    center: [40.0691, 45.0382],
  },
  ABW: {
    alpha2Code: 'AW',
    countryName: 'Aruba',
    center: [12.5211, -69.9683],
  },
  AUS: {
    alpha2Code: 'AU',
    countryName: 'Australia',
    center: [-25.2744, 133.7751],
  },
  AUT: {
    alpha2Code: 'AT',
    countryName: 'Austria',
    center: [47.5162, 14.5501],
  },
  AZE: {
    alpha2Code: 'AZ',
    countryName: 'Azerbaijan',
    center: [40.1431, 47.5769],
  },
  BHS: {
    alpha2Code: 'BS',
    countryName: 'Bahamas',
    center: [25.0343, -77.3963],
  },
  BHR: {
    alpha2Code: 'BH',
    countryName: 'Bahrain',
    center: [26.0667, 50.5577],
  },
  BGD: {
    alpha2Code: 'BD',
    countryName: 'Bangladesh',
    center: [23.685, 90.3563],
  },
  BRB: {
    alpha2Code: 'BB',
    countryName: 'Barbados',
    center: [13.1939, -59.5432],
  },
  BLR: {
    alpha2Code: 'BY',
    countryName: 'Belarus',
    center: [53.7098, 27.9534],
  },
  BEL: {
    alpha2Code: 'BE',
    countryName: 'Belgium',
    center: [50.5039, 4.4699],
  },
  BLZ: {
    alpha2Code: 'BZ',
    countryName: 'Belize',
    center: [17.1899, -88.4976],
  },
  BEN: {
    alpha2Code: 'BJ',
    countryName: 'Benin',
    center: [9.3077, 2.3158],
  },
  BMU: {
    alpha2Code: 'BM',
    countryName: 'Bermuda',
    center: [32.3078, -64.7505],
  },
  BTN: {
    alpha2Code: 'BT',
    countryName: 'Bhutan',
    center: [27.5142, 90.4336],
  },
  BOL: {
    alpha2Code: 'BO',
    countryName: 'Bolivia (Plurinational State of)',
    center: [-16.2902, -63.5887],
  },
  BES: {
    alpha2Code: 'BQ',
    countryName: 'Bonaire, Sint Eustatius and Saba',
    center: [12.2019, -68.2624],
  },
  BIH: {
    alpha2Code: 'BA',
    countryName: 'Bosnia and Herzegovina',
    center: [43.9159, 17.6791],
  },
  BWA: {
    alpha2Code: 'BW',
    countryName: 'Botswana',
    center: [-22.3285, 24.6849],
  },
  BVT: {
    alpha2Code: 'BV',
    countryName: 'Bouvet Island',
    center: [-54.4232, 3.4132],
  },
  BRA: {
    alpha2Code: 'BR',
    countryName: 'Brazil',
    center: [-14.235, -51.9253],
  },
  IOT: {
    alpha2Code: 'IO',
    countryName: 'British Indian Ocean Territory',
    center: [-6.3432, 71.8765],
  },
  BRN: {
    alpha2Code: 'BN',
    countryName: 'Brunei Darussalam',
    center: [4.5353, 114.7277],
  },
  BGR: {
    alpha2Code: 'BG',
    countryName: 'Bulgaria',
    center: [42.7339, 25.4858],
  },
  BFA: {
    alpha2Code: 'BF',
    countryName: 'Burkina Faso',
    center: [12.2383, -1.5616],
  },
  BDI: {
    alpha2Code: 'BI',
    countryName: 'Burundi',
    center: [-3.3731, 29.9189],
  },
  CPV: {
    alpha2Code: 'CV',
    countryName: 'Cabo Verde',
    center: [16.5388, -23.0418],
  },
  KHM: {
    alpha2Code: 'KH',
    countryName: 'Cambodia',
    center: [12.5657, 104.991],
  },
  CMR: {
    alpha2Code: 'CM',
    countryName: 'Cameroon',
    center: [7.3697, 12.3547],
  },
  CAN: {
    alpha2Code: 'CA',
    countryName: 'Canada',
    center: [56.1304, -106.3468],
  },
  CYM: {
    alpha2Code: 'KY',
    countryName: 'Cayman Islands',
    center: [19.3133, -81.2546],
  },
  CAF: {
    alpha2Code: 'CF',
    countryName: 'Central African Republic',
    center: [6.6111, 20.9394],
  },
  TCD: {
    alpha2Code: 'TD',
    countryName: 'Chad',
    center: [15.4542, 18.7322],
  },
  CHL: {
    alpha2Code: 'CL',
    countryName: 'Chile',
    center: [-35.6751, -71.543],
  },
  CHN: {
    alpha2Code: 'CN',
    countryName: 'China',
    center: [35.8617, 104.1954],
  },
  CXR: {
    alpha2Code: 'CX',
    countryName: 'Christmas Island',
    center: [-10.4475, 105.6904],
  },
  CCK: {
    alpha2Code: 'CC',
    countryName: 'Cocos (Keeling) Islands',
    center: [-12.1642, 96.871],
  },
  COL: {
    alpha2Code: 'CO',
    countryName: 'Colombia',
    center: [4.5709, -74.2973],
  },
  COM: {
    alpha2Code: 'KM',
    countryName: 'Comoros',
    center: [-11.6455, 43.3333],
  },
  COD: {
    alpha2Code: 'CD',
    countryName: 'Congo (the Democratic Republic of the)',
    center: [-4.0383, 21.7587],
  },
  COG: {
    alpha2Code: 'CG',
    countryName: 'Congo',
    center: [-0.228, 15.8277],
  },
  COK: {
    alpha2Code: 'CK',
    countryName: 'Cook Islands',
    center: [-21.2367, -159.7777],
  },
  CRI: {
    alpha2Code: 'CR',
    countryName: 'Costa Rica',
    center: [9.7489, -83.7534],
  },
  HRV: {
    alpha2Code: 'HR',
    countryName: 'Croatia',
    center: [45.1, 15.2],
  },
  CUB: {
    alpha2Code: 'CU',
    countryName: 'Cuba',
    center: [21.5218, -77.7812],
  },
  CUW: {
    alpha2Code: 'CW',
    countryName: 'Curaçao',
    center: [12.1696, -68.99],
  },
  CYP: {
    alpha2Code: 'CY',
    countryName: 'Cyprus',
    center: [35.1264, 33.4299],
  },
  CZE: {
    alpha2Code: 'CZ',
    countryName: 'Czechia',
    center: [49.8175, 15.4729],
  },
  CIV: {
    alpha2Code: 'CI',
    countryName: "Côte d'Ivoire",
    center: [7.54, -5.5471],
  },
  DNK: {
    alpha2Code: 'DK',
    countryName: 'Denmark',
    center: [56.2639, 9.5018],
  },
  DJI: {
    alpha2Code: 'DJ',
    countryName: 'Djibouti',
    center: [11.8251, 42.5903],
  },
  DMA: {
    alpha2Code: 'DM',
    countryName: 'Dominica',
    center: [15.414999, -61.370976],
  },
  DOM: {
    alpha2Code: 'DO',
    countryName: 'Dominican Republic',
    center: [18.735693, -70.162651],
  },
  ECU: {
    alpha2Code: 'EC',
    countryName: 'Ecuador',
    center: [-1.831239, -78.183406],
  },
  EGY: {
    alpha2Code: 'EG',
    countryName: 'Egypt',
    center: [26.820553, 30.802498],
  },
  SLV: {
    alpha2Code: 'SV',
    countryName: 'El Salvador',
    center: [13.794185, -88.89653],
  },
  GNQ: {
    alpha2Code: 'GQ',
    countryName: 'Equatorial Guinea',
    center: [1.650801, 10.267895],
  },
  ERI: {
    alpha2Code: 'ER',
    countryName: 'Eritrea',
    center: [15.179384, 39.782334],
  },
  EST: {
    alpha2Code: 'EE',
    countryName: 'Estonia',
    center: [58.595272, 25.013607],
  },
  SWZ: {
    alpha2Code: 'SZ',
    countryName: 'Eswatini',
    center: [-26.522503, 31.465866],
  },
  ETH: {
    alpha2Code: 'ET',
    countryName: 'Ethiopia',
    center: [9.145, 40.489673],
  },
  FLK: {
    alpha2Code: 'FK',
    countryName: 'Falkland Islands [Malvinas]',
    center: [-51.796253, -59.523613],
  },
  FRO: {
    alpha2Code: 'FO',
    countryName: 'Faroe Islands',
    center: [61.892635, -6.911806],
  },
  FJI: {
    alpha2Code: 'FJ',
    countryName: 'Fiji',
    center: [-17.713371, 178.065032],
  },
  FIN: {
    alpha2Code: 'FI',
    countryName: 'Finland',
    center: [61.92411, 25.748151],
  },
  GUF: {
    alpha2Code: 'GF',
    countryName: 'French Guiana',
    center: [3.9339, -53.1258],
  },
  PYF: {
    alpha2Code: 'PF',
    countryName: 'French Polynesia',
    center: [-17.6797, -149.4068],
  },
  ATF: {
    alpha2Code: 'TF',
    countryName: 'French Southern Territories',
    center: [-49.2804, 69.3486],
  },
  GAB: {
    alpha2Code: 'GA',
    countryName: 'Gabon',
    center: [-0.8037, 11.6094],
  },
  GMB: {
    alpha2Code: 'GM',
    countryName: 'Gambia',
    center: [13.4432, -15.3101],
  },
  GEO: {
    alpha2Code: 'GE',
    countryName: 'Georgia',
    center: [42.3154, 43.3569],
  },
  GHA: {
    alpha2Code: 'GH',
    countryName: 'Ghana',
    center: [7.9465, -1.0232],
  },
  GIB: {
    alpha2Code: 'GI',
    countryName: 'Gibraltar',
    center: [36.1408, -5.3536],
  },
  GRC: {
    alpha2Code: 'GR',
    countryName: 'Greece',
    center: [39.0742, 21.8243],
  },
  GRL: {
    alpha2Code: 'GL',
    countryName: 'Greenland',
    center: [71.7069, -42.6043],
  },
  GRD: {
    alpha2Code: 'GD',
    countryName: 'Grenada',
    center: [12.1165, -61.679],
  },
  GLP: {
    alpha2Code: 'GP',
    countryName: 'Guadeloupe',
    center: [16.265, -61.551],
  },
  GUM: {
    alpha2Code: 'GU',
    countryName: 'Guam',
    center: [13.4443, 144.7937],
  },
  GTM: {
    alpha2Code: 'GT',
    countryName: 'Guatemala',
    center: [15.7835, -90.2308],
  },
  GGY: {
    alpha2Code: 'GG',
    countryName: 'Guernsey',
    center: [49.4657, -2.5853],
  },
  GIN: {
    alpha2Code: 'GN',
    countryName: 'Guinea',
    center: [9.9456, -9.6966],
  },
  GNB: {
    alpha2Code: 'GW',
    countryName: 'Guinea-Bissau',
    center: [11.8037, -15.1804],
  },
  GUY: {
    alpha2Code: 'GY',
    countryName: 'Guyana',
    center: [4.8604, -58.9302],
  },
  HTI: {
    alpha2Code: 'HT',
    countryName: 'Haiti',
    center: [18.9712, -72.2852],
  },
  HMD: {
    alpha2Code: 'HM',
    countryName: 'Heard Island and McDonald Islands',
    center: [-53.0818, 73.5042],
  },
  VAT: {
    alpha2Code: 'VA',
    countryName: 'Holy See',
    center: [41.9029, 12.4534],
  },
  HND: {
    alpha2Code: 'HN',
    countryName: 'Honduras',
    center: [15.2, -86.2419],
  },
  HKG: {
    alpha2Code: 'HK',
    countryName: 'Hong Kong',
    center: [22.3193, 114.1694],
  },
  HUN: {
    alpha2Code: 'HU',
    countryName: 'Hungary',
    center: [47.1625, 19.5033],
  },
  ISL: {
    alpha2Code: 'IS',
    countryName: 'Iceland',
    center: [64.9631, -19.0208],
  },
  IND: {
    alpha2Code: 'IN',
    countryName: 'India',
    center: [20.5937, 78.9629],
  },
  IDN: {
    alpha2Code: 'ID',
    countryName: 'Indonesia',
    center: [-0.7893, 113.9213],
  },
  IRN: {
    alpha2Code: 'IR',
    countryName: 'Iran (Islamic Republic of)',
    center: [32.4279, 53.688],
  },
  IRQ: {
    alpha2Code: 'IQ',
    countryName: 'Iraq',
    center: [33.2232, 43.6793],
  },
  IRL: {
    alpha2Code: 'IE',
    countryName: 'Ireland',
    center: [53.1424, -7.6921],
  },
  IMN: {
    alpha2Code: 'IM',
    countryName: 'Isle of Man',
    center: [54.2361, -4.5481],
  },
  JAM: {
    alpha2Code: 'JM',
    countryName: 'Jamaica',
    center: [18.1096, -77.2975],
  },
  JPN: {
    alpha2Code: 'JP',
    countryName: 'Japan',
    center: [36.2048, 138.2529],
  },
  JEY: {
    alpha2Code: 'JE',
    countryName: 'Jersey',
    center: [49.2144, -2.1313],
  },
  JOR: {
    alpha2Code: 'JO',
    countryName: 'Jordan',
    center: [30.5852, 36.2384],
  },
  KAZ: {
    alpha2Code: 'KZ',
    countryName: 'Kazakhstan',
    center: [48.0196, 66.9237],
  },
  KEN: {
    alpha2Code: 'KE',
    countryName: 'Kenya',
    center: [-1.2864, 36.8172],
  },
  KIR: {
    alpha2Code: 'KI',
    countryName: 'Kiribati',
    center: [-3.3704, -168.734],
  },
  PRK: {
    alpha2Code: 'KP',
    countryName: "Korea (the Democratic People's Republic of)",
    center: [40.3399, 127.5101],
  },
  KOR: {
    alpha2Code: 'KR',
    countryName: 'Korea (the Republic of)',
    center: [35.9078, 127.7669],
  },
  KWT: {
    alpha2Code: 'KW',
    countryName: 'Kuwait',
    center: [29.3117, 47.4818],
  },
  KGZ: {
    alpha2Code: 'KG',
    countryName: 'Kyrgyzstan',
    center: [41.2044, 74.7661],
  },
  LAO: {
    alpha2Code: 'LA',
    countryName: "Lao People's Democratic Republic",
    center: [19.8563, 102.4955],
  },
  LVA: {
    alpha2Code: 'LV',
    countryName: 'Latvia',
    center: [56.8796, 24.6032],
  },
  LBN: {
    alpha2Code: 'LB',
    countryName: 'Lebanon',
    center: [33.8547, 35.8623],
  },
  LSO: {
    alpha2Code: 'LS',
    countryName: 'Lesotho',
    center: [-29.6099, 28.2336],
  },
  LBR: {
    alpha2Code: 'LR',
    countryName: 'Liberia',
    center: [6.4281, -9.4295],
  },
  LBY: {
    alpha2Code: 'LY',
    countryName: 'Libya',
    center: [26.3351, 17.2283],
  },
  LIE: {
    alpha2Code: 'LI',
    countryName: 'Liechtenstein',
    center: [47.166, 9.5554],
  },

  LTU: {
    alpha2Code: 'LT',
    countryName: 'Lithuania',
    center: [55.1694, 23.8813],
  },
  LUX: {
    alpha2Code: 'LU',
    countryName: 'Luxembourg',
    center: [49.8153, 6.1296],
  },
  MAC: {
    alpha2Code: 'MO',
    countryName: 'Macao',
    center: [22.1987, 113.5439],
  },
  MDG: {
    alpha2Code: 'MG',
    countryName: 'Madagascar',
    center: [-18.7669, 46.8691],
  },
  MWI: {
    alpha2Code: 'MW',
    countryName: 'Malawi',
    center: [-13.2543, 34.3015],
  },
  MYS: {
    alpha2Code: 'MY',
    countryName: 'Malaysia',
    center: [4.2105, 101.9758],
  },
  MDV: {
    alpha2Code: 'MV',
    countryName: 'Maldives',
    center: [3.2028, 73.2207],
  },
  MLI: {
    alpha2Code: 'ML',
    countryName: 'Mali',
    center: [17.5707, -3.9962],
  },
  MLT: {
    alpha2Code: 'MT',
    countryName: 'Malta',
    center: [35.8997, 14.5146],
  },
  MHL: {
    alpha2Code: 'MH',
    countryName: 'Marshall Islands',
    center: [7.1315, 171.1845],
  },
  MTQ: {
    alpha2Code: 'MQ',
    countryName: 'Martinique',
    center: [14.6415, -61.0242],
  },
  MRT: {
    alpha2Code: 'MR',
    countryName: 'Mauritania',
    center: [21.0079, -10.9408],
  },
  MUS: {
    alpha2Code: 'MU',
    countryName: 'Mauritius',
    center: [-20.3484, 57.5522],
  },
  MYT: {
    alpha2Code: 'YT',
    countryName: 'Mayotte',
    center: [-12.8275, 45.1662],
  },
  MEX: {
    alpha2Code: 'MX',
    countryName: 'Mexico',
    center: [23.6345, -102.5528],
  },
  FSM: {
    alpha2Code: 'FM',
    countryName: 'Micronesia (Federated States of)',
    center: [7.4256, 150.5508],
  },
  MDA: {
    alpha2Code: 'MD',
    countryName: 'Moldova (the Republic of)',
    center: [47.4116, 28.3699],
  },
  MCO: {
    alpha2Code: 'MC',
    countryName: 'Monaco',
    center: [43.7384, 7.4246],
  },
  MNG: {
    alpha2Code: 'MN',
    countryName: 'Mongolia',
    center: [46.8625, 103.8467],
  },
  MNE: {
    alpha2Code: 'ME',
    countryName: 'Montenegro',
    center: [42.7087, 19.3744],
  },
  MSR: {
    alpha2Code: 'MS',
    countryName: 'Montserrat',
    center: [16.7425, -62.1874],
  },
  MAR: {
    alpha2Code: 'MA',
    countryName: 'Morocco',
    center: [31.7917, -7.0926],
  },
  MOZ: {
    alpha2Code: 'MZ',
    countryName: 'Mozambique',
    center: [-18.6657, 35.5296],
  },
  MMR: {
    alpha2Code: 'MM',
    countryName: 'Myanmar',
    center: [21.9162, 95.956],
  },
  NAM: {
    alpha2Code: 'NA',
    countryName: 'Namibia',
    center: [-22.9576, 18.4904],
  },
  NRU: {
    alpha2Code: 'NR',
    countryName: 'Nauru',
    center: [-0.5228, 166.9315],
  },
  NPL: {
    alpha2Code: 'NP',
    countryName: 'Nepal',
    center: [28.3949, 84.124],
  },
  NLD: {
    alpha2Code: 'NL',
    countryName: 'Netherlands',
    center: [52.1326, 5.2913],
  },
  NCL: {
    alpha2Code: 'NC',
    countryName: 'New Caledonia',
    center: [-20.9043, 165.618],
  },
  NZL: {
    alpha2Code: 'NZ',
    countryName: 'New Zealand',
    center: [-40.9006, 174.886],
  },
  NIC: {
    alpha2Code: 'NI',
    countryName: 'Nicaragua',
    center: [12.8654, -85.2072],
  },
  NER: {
    alpha2Code: 'NE',
    countryName: 'Niger',
    center: [17.6078, 8.0817],
  },
  NGA: {
    alpha2Code: 'NG',
    countryName: 'Nigeria',
    center: [9.082, 8.6753],
  },
  NIU: {
    alpha2Code: 'NU',
    countryName: 'Niue',
    center: [-19.0544, -169.8672],
  },
  NFK: {
    alpha2Code: 'NF',
    countryName: 'Norfolk Island',
    center: [-29.0333, 167.95],
  },
  MKD: {
    alpha2Code: 'MK',
    countryName: 'North Macedonia',
    center: [41.6086, 21.7453],
  },
  MNP: {
    alpha2Code: 'MP',
    countryName: 'Northern Mariana Islands',
    center: [15.0979, 145.6739],
  },
  NOR: {
    alpha2Code: 'NO',
    countryName: 'Norway',
    center: [60.472, 8.4689],
  },
  OMN: {
    alpha2Code: 'OM',
    countryName: 'Oman',
    center: [21.5126, 55.9233],
  },
  PAK: {
    alpha2Code: 'PK',
    countryName: 'Pakistan',
    center: [30.3753, 69.3451],
  },
  PLW: {
    alpha2Code: 'PW',
    countryName: 'Palau',
    center: [7.5149, 134.5825],
  },
  PAN: {
    alpha2Code: 'PA',
    countryName: 'Panama',
    center: [8.5379, -80.7821],
  },
  PNG: {
    alpha2Code: 'PG',
    countryName: 'Papua New Guinea',
    center: [-6.3149, 143.9555],
  },
  PRY: {
    alpha2Code: 'PY',
    countryName: 'Paraguay',
    center: [-23.4425, -58.4438],
  },
  PER: {
    alpha2Code: 'PE',
    countryName: 'Peru',
    center: [-9.1899, -75.0152],
  },
  PHL: {
    alpha2Code: 'PH',
    countryName: 'Philippines',
    center: [12.8797, 121.774],
  },
  PCN: {
    alpha2Code: 'PN',
    countryName: 'Pitcairn',
    center: [-24.7036, -127.4393],
  },
  POL: {
    alpha2Code: 'PL',
    countryName: 'Poland',
    center: [51.9194, 19.1451],
  },
  PRT: {
    alpha2Code: 'PT',
    countryName: 'Portugal',
    center: [39.3999, -8.2245],
  },
  PRI: {
    alpha2Code: 'PR',
    countryName: 'Puerto Rico',
    center: [18.2208, -66.5901],
  },
  QAT: {
    alpha2Code: 'QA',
    countryName: 'Qatar',
    center: [25.3548, 51.1839],
  },
  ROU: {
    alpha2Code: 'RO',
    countryName: 'Romania',
    center: [45.9432, 24.9668],
  },
  RUS: {
    alpha2Code: 'RU',
    countryName: 'Russian Federation',
    center: [61.524, 105.3188],
  },
  RWA: {
    alpha2Code: 'RW',
    countryName: 'Rwanda',
    center: [-1.9403, 29.8739],
  },
  REU: {
    alpha2Code: 'RE',
    countryName: 'Réunion',
    center: [-21.1151, 55.5364],
  },
  BLM: {
    alpha2Code: 'BL',
    countryName: 'Saint Barthélemy',
    center: [17.9, -62.8333],
  },
  SHN: {
    alpha2Code: 'SH',
    countryName: 'Saint Helena, Ascension and Tristan da Cunha',
    center: [-15.965, -5.7089],
  },
  KNA: {
    alpha2Code: 'KN',
    countryName: 'Saint Kitts and Nevis',
    center: [17.3578, -62.783],
  },
  LCA: {
    alpha2Code: 'LC',
    countryName: 'Saint Lucia',
    center: [13.9094, -60.9789],
  },
  MAF: {
    alpha2Code: 'MF',
    countryName: 'Saint Martin (French part)',
    center: [18.0708, -63.0501],
  },
  SPM: {
    alpha2Code: 'PM',
    countryName: 'Saint Pierre and Miquelon',
    center: [46.8852, -56.3159],
  },
  VCT: {
    alpha2Code: 'VC',
    countryName: 'Saint Vincent and the Grenadines',
    center: [12.9843, -61.2872],
  },
  WSM: {
    alpha2Code: 'WS',
    countryName: 'Samoa',
    center: [-13.759, -172.1046],
  },
  SMR: {
    alpha2Code: 'SM',
    countryName: 'San Marino',
    center: [43.9336, 12.45],
  },
  STP: {
    alpha2Code: 'ST',
    countryName: 'Sao Tome and Principe',
    center: [0.1864, 6.6131],
  },
  SAU: {
    alpha2Code: 'SA',
    countryName: 'Saudi Arabia',
    center: [23.8859, 45.0792],
  },
  SEN: {
    alpha2Code: 'SN',
    countryName: 'Senegal',
    center: [14.4974, -14.4524],
  },
  SRB: {
    alpha2Code: 'RS',
    countryName: 'Serbia',
    center: [44.0165, 21.0059],
  },
  SYC: {
    alpha2Code: 'SC',
    countryName: 'Seychelles',
    center: [-4.6796, 55.492],
  },
  SLE: {
    alpha2Code: 'SL',
    countryName: 'Sierra Leone',
    center: [8.4606, -11.7799],
  },
  SGP: {
    alpha2Code: 'SG',
    countryName: 'Singapore',
    center: [1.3521, 103.8198],
  },
  SXM: {
    alpha2Code: 'SX',
    countryName: 'Sint Maarten (Dutch part)',
    center: [18.0425, -63.0548],
  },
  SVK: {
    alpha2Code: 'SK',
    countryName: 'Slovakia',
    center: [48.669, 19.699],
  },
  SVN: {
    alpha2Code: 'SI',
    countryName: 'Slovenia',
    center: [46.1512, 14.9955],
  },
  SLB: {
    alpha2Code: 'SB',
    countryName: 'Solomon Islands',
    center: [-9.6457, 160.1562],
  },
  SOM: {
    alpha2Code: 'SO',
    countryName: 'Somalia',
    center: [5.1521, 46.1996],
  },
  ZAF: {
    alpha2Code: 'ZA',
    countryName: 'South Africa',
    center: [-30.5595, 22.9375],
  },
  SGS: {
    alpha2Code: 'GS',
    countryName: 'South Georgia and the South Sandwich Islands',
    center: [-54.4296, -36.5879],
  },
  SSD: {
    alpha2Code: 'SS',
    countryName: 'South Sudan',
    center: [7.8627, 30.2176],
  },
  LKA: {
    alpha2Code: 'LK',
    countryName: 'Sri Lanka',
    center: [7.8731, 80.7718],
  },
  SDN: {
    alpha2Code: 'SD',
    countryName: 'Sudan',
    center: [12.8628, 30.2176],
  },
  SUR: {
    alpha2Code: 'SR',
    countryName: 'Suriname',
    center: [3.9193, -56.0278],
  },
  SJM: {
    alpha2Code: 'SJ',
    countryName: 'Svalbard and Jan Mayen',
    center: [77.5536, 23.6703],
  },
  SWE: {
    alpha2Code: 'SE',
    countryName: 'Sweden',
    center: [60.1282, 18.6435],
  },
  CHE: {
    alpha2Code: 'CH',
    countryName: 'Switzerland',
    center: [46.8182, 8.2275],
  },
  SYR: {
    alpha2Code: 'SY',
    countryName: 'Syrian Arab Republic',
    center: [34.8021, 38.9968],
  },
  TWN: {
    alpha2Code: 'TW',
    countryName: 'Taiwan',
    center: [23.6978, 120.9605],
  },
  TJK: {
    alpha2Code: 'TJ',
    countryName: 'Tajikistan',
    center: [38.861, 71.2761],
  },
  TZA: {
    alpha2Code: 'TZ',
    countryName: 'Tanzania, the United Republic of',
    center: [-6.369, 34.8888],
  },
  THA: {
    alpha2Code: 'TH',
    countryName: 'Thailand',
    center: [15.87, 100.9925],
  },
  TLS: {
    alpha2Code: 'TL',
    countryName: 'Timor-Leste',
    center: [-8.8742, 125.7275],
  },
  TGO: {
    alpha2Code: 'TG',
    countryName: 'Togo',
    center: [8.6195, 0.8248],
  },
  TKL: {
    alpha2Code: 'TK',
    countryName: 'Tokelau',
    center: [-9.2, -171.8333],
  },
  TON: {
    alpha2Code: 'TO',
    countryName: 'Tonga',
    center: [-21.1789, -175.1982],
  },
  TTO: {
    alpha2Code: 'TT',
    countryName: 'Trinidad and Tobago',
    center: [10.6918, -61.2225],
  },
  TUN: {
    alpha2Code: 'TN',
    countryName: 'Tunisia',
    center: [33.8869, 9.5375],
  },
  TUR: {
    alpha2Code: 'TR',
    countryName: 'Turkey',
    center: [38.9637, 35.2433],
  },
  TKM: {
    alpha2Code: 'TM',
    countryName: 'Turkmenistan',
    center: [38.9697, 59.5563],
  },
  TCA: {
    alpha2Code: 'TC',
    countryName: 'Turks and Caicos Islands',
    center: [21.694, -71.7979],
  },
  TUV: {
    alpha2Code: 'TV',
    countryName: 'Tuvalu',
    center: [-7.1095, 177.6493],
  },
  UGA: {
    alpha2Code: 'UG',
    countryName: 'Uganda',
    center: [1.3733, 32.2903],
  },
  UKR: {
    alpha2Code: 'UA',
    countryName: 'Ukraine',
    center: [48.3794, 31.1656],
  },
  ARE: {
    alpha2Code: 'AE',
    countryName: 'United Arab Emirates',
    center: [23.4241, 53.8478],
  },
  UMI: {
    alpha2Code: 'UM',
    countryName: 'United States Minor Outlying Islands',
    center: [19.2823, 166.647],
  },
  URY: {
    alpha2Code: 'UY',
    countryName: 'Uruguay',
    center: [-32.5228, -55.7658],
  },
  UZB: {
    alpha2Code: 'UZ',
    countryName: 'Uzbekistan',
    center: [41.3775, 64.5853],
  },
  VUT: {
    alpha2Code: 'VU',
    countryName: 'Vanuatu',
    center: [-15.3767, 166.9592],
  },
  VEN: {
    alpha2Code: 'VE',
    countryName: 'Venezuela (Bolivarian Republic of)',
    center: [6.4238, -66.5897],
  },
  VNM: {
    alpha2Code: 'VN',
    countryName: 'Vietnam',
    center: [14.0583, 108.2772],
  },
  VGB: {
    alpha2Code: 'VG',
    countryName: 'Virgin Islands (British)',
    center: [18.4207, -64.6399],
  },
  VIR: {
    alpha2Code: 'VI',
    countryName: 'Virgin Islands (U.S.)',
    center: [18.3358, -64.8963],
  },
  WLF: {
    alpha2Code: 'WF',
    countryName: 'Wallis and Futuna',
    center: [-13.7687, -177.1561],
  },
  ESH: {
    alpha2Code: 'EH',
    countryName: 'Western Sahara*',
    center: [24.2155, -12.8858],
  },
  YEM: {
    alpha2Code: 'YE',
    countryName: 'Yemen',
    center: [15.5527, 48.5164],
  },
  ZMB: {
    alpha2Code: 'ZM',
    countryName: 'Zambia',
    center: [-13.1339, 27.8493],
  },
  ZWE: {
    alpha2Code: 'ZW',
    countryName: 'Zimbabwe',
    center: [-19.0154, 29.1549],
  },
  ALA: {
    alpha2Code: 'AX',
    countryName: 'Åland Islands',
    center: [60.1785, 19.9156],
  },
}

export const COUNTRY_REGIONS_MAP = {
  USA: [
    { regionCode: 'AL', regionName: 'Alabama' },
    { regionCode: 'AK', regionName: 'Alaska' },
    { regionCode: 'AZ', regionName: 'Arizona' },
    { regionCode: 'AR', regionName: 'Arkansas' },
    { regionCode: 'CA', regionName: 'California' },
    { regionCode: 'CO', regionName: 'Colorado' },
    { regionCode: 'CT', regionName: 'Connecticut' },
    { regionCode: 'DE', regionName: 'Delaware' },
    { regionCode: 'FL', regionName: 'Florida' },
    { regionCode: 'GA', regionName: 'Georgia' },
    { regionCode: 'HI', regionName: 'Hawaii' },
    { regionCode: 'ID', regionName: 'Idaho' },
    { regionCode: 'IL', regionName: 'Illinois' },
    { regionCode: 'IN', regionName: 'Indiana' },
    { regionCode: 'IA', regionName: 'Iowa' },
    { regionCode: 'KS', regionName: 'Kansas' },
    { regionCode: 'KY', regionName: 'Kentucky' },
    { regionCode: 'LA', regionName: 'Louisiana' },
    { regionCode: 'ME', regionName: 'Maine' },
    { regionCode: 'MD', regionName: 'Maryland' },
    { regionCode: 'MA', regionName: 'Massachusetts' },
    { regionCode: 'MI', regionName: 'Michigan' },
    { regionCode: 'MN', regionName: 'Minnesota' },
    { regionCode: 'MS', regionName: 'Mississippi' },
    { regionCode: 'MO', regionName: 'Missouri' },
    { regionCode: 'MT', regionName: 'Montana' },
    { regionCode: 'NE', regionName: 'Nebraska' },
    { regionCode: 'NV', regionName: 'Nevada' },
    { regionCode: 'NH', regionName: 'New Hampshire' },
    { regionCode: 'NJ', regionName: 'New Jersey' },
    { regionCode: 'NM', regionName: 'New Mexico' },
    { regionCode: 'NY', regionName: 'New York' },
    { regionCode: 'NC', regionName: 'North Carolina' },
    { regionCode: 'ND', regionName: 'North Dakota' },
    { regionCode: 'OH', regionName: 'Ohio' },
    { regionCode: 'OK', regionName: 'Oklahoma' },
    { regionCode: 'OR', regionName: 'Oregon' },
    { regionCode: 'PA', regionName: 'Pennsylvania' },
    { regionCode: 'RI', regionName: 'Rhode Island' },
    { regionCode: 'SC', regionName: 'South Carolina' },
    { regionCode: 'SD', regionName: 'South Dakota' },
    { regionCode: 'TN', regionName: 'Tennessee' },
    { regionCode: 'TX', regionName: 'Texas' },
    { regionCode: 'UT', regionName: 'Utah' },
    { regionCode: 'VT', regionName: 'Vermont' },
    { regionCode: 'VA', regionName: 'Virginia' },
    { regionCode: 'WA', regionName: 'Washington' },
    { regionCode: 'WV', regionName: 'West Virginia' },
    { regionCode: 'WI', regionName: 'Wisconsin' },
    { regionCode: 'WY', regionName: 'Wyoming' },
    { regionCode: 'DC', regionName: 'District of Columbia' },
    { regionCode: 'AS', regionName: 'American Samoa	Outlying area' },
    { regionCode: 'GU', regionName: 'Guam	Outlying area' },
    { regionCode: 'MP', regionName: 'Northern Mariana Islands	Outlying area' },
    { regionCode: 'PR', regionName: 'Puerto Rico	Outlying area' },
    { regionCode: 'UM', regionName: 'United States Minor Outlying Islands	Outlying area' },
    { regionCode: 'VI', regionName: 'Virgin Islands, U.S.Outlying area' },
  ],
  GBR: [
    { regionCode: 'ENG', regionName: 'England' },
    { regionCode: 'NIR', regionName: 'Northern Ireland' },
    { regionCode: 'SCT', regionName: 'Scotland' },
    { regionCode: 'WLS', regionName: 'Wales' },
  ],
  DEU: [
    { regionCode: 'BW', regionName: 'Baden-Württemberg' },
    { regionCode: 'BY', regionName: 'Bavaria' },
    { regionCode: 'BE', regionName: 'Berlin' },
    { regionCode: 'BB', regionName: 'Brandenburg' },
    { regionCode: 'HB', regionName: 'Bremen' },
    { regionCode: 'HH', regionName: 'Hamburg' },
    { regionCode: 'HE', regionName: 'Hesse' },
    { regionCode: 'MV', regionName: 'Mecklenburg-Western Pomerania' },
    { regionCode: 'NI', regionName: 'Lower Saxony' },
    { regionCode: 'NW', regionName: 'North Rhine-Westphalia' },
    { regionCode: 'RP', regionName: 'Rhineland-Palatinate' },
    { regionCode: 'SL', regionName: 'Saarland' },
    { regionCode: 'SN', regionName: 'Saxony' },
    { regionCode: 'ST', regionName: 'Saxony-Anhalt' },
    { regionCode: 'SH', regionName: 'Schleswig-Holstein' },
    { regionCode: 'TH', regionName: 'Thuringia' },
  ],
}
